<template>
  <div class="balance py-6 px-8">
    <h-header>
      <template v-slot:actions>
        <v-btn
          @click="() => createUpdate()"
          color="primary"
          target="_blank"
          elevation="0"
        >
          <v-icon left>
            mdi-plus
          </v-icon>
          <span class="d-none d-md-flex body-2">
            {{ $t('mission.actions.create') }}
          </span>
        </v-btn>
      </template>
    </h-header>

    <MissionListFilter />

    <v-card outlined>
      <v-data-table
        disable-sort
        hide-default-footer
        mobile-breakpoint="20"
        :headers="headers"
        :items="missions"
        :loading="isLoading"
        :items-per-page="itemsPerPage"
        :no-data-text="$t('appointment.table.noData')"
        :loading-text="$t('appointment.table.loading')"
        @dblclick:row="showMissionRow"
        class="clickable"
      >
        <template v-slot:[`item.start_date`]="{ item }">
          <span class="text-center">
            {{ formatDate(item.start_date) }}
          </span>
        </template>
        <template v-slot:[`item.end_date`]="{ item }">
          <span class="text-center">
            {{ formatDate(item.end_date) }}
          </span>
        </template>
        <template v-slot:[`item.price`]="{ item }">
          <span class="text-center">
            {{ formatMoney(item.price) }}
          </span>
        </template>
        <template v-slot:[`item.active`]="{ item }">
          <IconIsActive
            :is-active="item.active"
            :subtitle="$t(`mission.status.${item.active}`)"
          />
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <MissionListRowMenu
            :mission="item"
            @showMission="showMission"
            @createUpdate="createUpdate"
            @duplicateMission="duplicateMission"
            @getMissionStatus="getMissionStatus"
          />
        </template>
      </v-data-table>
    </v-card>

    <h-pagination :fetch="fetchMissions" />

    <MissionCreateUpdate ref="createMission" />

    <RightDrawer :moreInfo="false">
      <MissionSummary :data="mission" />
    </RightDrawer>
  </div>
</template>

<script>
import router from '@/router'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { catalogDate, catalogMonetary } from '@/util/catalog'
import { missionHeaders } from './listHeaders/missionHeaders'

import IconIsActive from '@/components/IconIsActive'
import RightDrawer from '@/components/app/RightDrawer'
import MissionSummary from '@/components/missions/MissionSummary'
import MissionListFilter from '@/components/missions/MissionListFilter'
import MissionCreateUpdate from '@/components/missions/modals/MissionCreateUpdate'
import MissionListRowMenu from '@/components/missions/components/MissionListRowMenu'


export default {
  name: 'MissionList',

  components: {
    RightDrawer,
    IconIsActive,
    MissionSummary,
    MissionListFilter,
    MissionCreateUpdate,
    MissionListRowMenu,
  },

  data() {
    return {
      headers: missionHeaders,
    }
  },

  computed: {
    ...mapGetters([
      'itemsPerPage',
      'isLoading',
      'missions',
      'mission',
    ]),
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),

    ...mapActions([
      'handleOpenCreateMissionModal',
      'handleDuplicateMissionModal',
      'fetchMissions',
      'fetchMission',
    ]),

    formatDate(date) {
      return catalogDate(date)
    },

    formatAppointmentType(type, arrayIndex, servicesLength) {
      return (
        this.$t(`appointment.type.${type}`) +
        (arrayIndex < servicesLength ? ',' : '')
      )
    },

    showMission(id) {
      this.fetchMission(id)
      this.setIsDrawerOpen()
    },

    showMissionRow(_, { item }) {
      this.showMission(item.id)
    },

    getMissionStatus(id) {
      router.push(`/mission-progress/${id}`)
    },

    createUpdate(id) {
      this.$refs.createMission?.resetFields()
      this.$nextTick(() => this.handleOpenCreateMissionModal(id))
    },

    duplicateMission(id) {
      this.$refs.createMission?.resetFields()
      this.$nextTick(() => this.handleDuplicateMissionModal(id))
    },

    formatMoney(price) {
      return price ? catalogMonetary(price) : '---'
    },
  },

  mounted() {
    this.fetchMissions()
  },
}
</script>
